/* eslint-disable @typescript-eslint/naming-convention */
export enum EnrollmentStatus {
  Enrolled,
  Graduated,
  Transferred,
  Terminated,
  PendingEnrollment,
  PendingGraduation,
  FutureCourse,
  Paused = 999,
}
